import { useCourseBusyGate } from './useCourseBusyGate'
import type { useAiChat } from './useAiChat'
import type { StudioJobType } from '@/features/ai/studioTypes'

/**
 * Перецепляет реестр курса на другой прогон и приводит панель в
 * консистентное состояние после этого (не «glue ради лимита строк»,
 * а держатель РЕШЕНИЯ о перецеплении — какой именно экран показать по
 * итогу решает `SidebarBody`, у которого уже есть `mode`/`chat`/`busy`).
 *
 * `mode` → `'idle'`, иначе привязанный прогресс/итог тут же перебивает
 * экран настроек (I-3); баннер отказа гасим явно — иначе «Курс занят
 * прогоном #45» висит под уже привязанным прогрессом того же прогона (M-1).
 */
export const useSidebarBusyFlow = (
  courseId: number,
  isOpen: boolean,
  setMode: (mode: 'idle') => void,
  chat: ReturnType<typeof useAiChat>,
) => {
  const { activeJob, isBusy, showRun } = useCourseBusyGate(courseId, isOpen)

  const handleShowRun = (jobId: number, jobType: StudioJobType) => {
    showRun(jobId, jobType)
    chat.resetFailure()
    setMode('idle')
  }

  return { activeJob, isBusy, handleShowRun }
}
